// App Imports
import params from '../../../setup/config/params'
import Detail from '../Detail'
import DetailWrapper from '../Detail/DetailWrapper';
import Print from '../Print/index'
import OrderTabs from "../OrderTabs";


// Pages routes
const routes = {
  orderSearch: {
    path: (page = ':page') => `/orders/${ page }`,
    activePath: '/order',
    component: OrderTabs,
    auth: true,
    role: [params.user.roles.admin.key, params.user.roles.vendor.key],
    module: "store",
    subModule: "orders.orderHistory",
    action: "canView"
  },


  orderList: {
    path: (page = ':page') => `/orders/${ page }`,
    activePath: '/orders',
    component: OrderTabs,
    auth: true,
    role: [params.user.roles.admin.key, params.user.roles.vendor.key],
    module: "store",
    subModule: "orders.orderHistory",
    action: "canView"
  },
  
  orderDetail: {
    path: (orderId = ':orderId') => (`/order/detail/${ orderId }`),
    //component: Detail,
    component: DetailWrapper,
    auth: true,
    role: [params.user.roles.admin.key, params.user.roles.vendor.key],
    module: "store",
    subModule: "orders.orderHistory",
    action: "canView"
  },
  orderPrint: {
    path:(orderId = ':orderId') => (`/order/print/${ orderId }`),
    component: Print,
    auth: true,
    role: [params.user.roles.admin.key, params.user.roles.vendor.key],
    module: "store",
    subModule: "orders.orderHistory",
    action: "canView"
  },
  orderLive: {
    path: (page = ':page') => `/liveorders/${page}`,
    component: OrderTabs,
    auth: true,
    role: [params.user.roles.admin.key, params.user.roles.vendor.key],
    module: "store",
    subModule: "orders.liveOrders",
    action: "canView"
  },
  
}

export default routes;